import React, { useEffect, useState } from 'react';
import { ClickElement } from '../form';
import { Link } from 'react-router-dom';
import { TOPZOVEEL } from '../../lib/labels';
import { Loading } from '../loading';
import styles from './StemPage.css';

export const CountDown = ({ startAtDate, endAtDate, ElementAbove, ElementUnder, mobile }) => {
  
  const now = new Date().getTime();
  const startDate = new Date(startAtDate);
  const endDate = new Date(endAtDate).getTime();
  const [curr, setCurr] = useState({
    d: null,
    h: null,
    m: null,
    s: null,
  });
  const { d, h, m, s } = curr;

  useEffect(() => {
    setInterval(() => {
      const now = new Date().getTime();
      const distance = endDate - now;
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      setCurr({ d: days, h: hours, m: minutes, s: seconds });
    }, 1000);
  }, []);

  return(<>
    {((now >= startDate) && (now <= endDate)) && (
      <>
        {d === null && <Loading extraSmallLoader showSuffix={false}/>}
        {d !== null && (
          <div 
            className={styles['counter-wrap']}
            style={mobile 
              ? { maxWidth: '400px', margin: '0 auto' } 
              : { marginTop: '20px', marginBottom: '10px' } }
          >
            <ElementAbove />
            <div className={styles['vote-text']}>Stemmen kan nog:</div>
            <div className={styles['counter']}>
              <div>
                <div>{d}</div>
                <div>{d === 1 ? 'dag' : 'dagen'}</div>
              </div>
              <div>
                <div>{h}</div>
                <div>{h=== 1 ? 'uur' : 'uren'}</div>
              </div>
              <div>
                <div>{m}</div>
                <div>{m === 1 ? 'minuut' : 'minuten'}</div>
              </div>
              <div>
                <div>{s}</div>
                <div>{s === 1 ? 'seconde' : 'seconden'}</div>
              </div>
            </div>
            <ElementUnder />
          </div>
        )}
      </>
    )}
  </>);

};

export const StemSidebarBlock = ({ mobile }) => {

  const startDate = 'November 29, 2023 17:00:00 GMT+0100';
  const endDate = 'December 13, 2023 23:59:00 GMT+0100';

  return(
    <CountDown 
      startAtDate={startDate} 
      endAtDate={endDate}
      mobile={mobile}
      ElementAbove={() => <Link to="/stem">
        <img src={TOPZOVEEL.IMAGES.LOGO} alt="Dumpert TopZoveel" width="100%" />
      </Link>
      }
      ElementUnder={
        () => 
          <ClickElement
            primary
            ElementType={Link}
            text="stemmen"
            to="/stem"
          />
      }
    />
  ); 
};
